<template>
  <div class="centerBox">
    <common-title titleName="个人中心" :bcColor="'#FEFEFF'" :beforeExec="goHome" :zIndex="1000">
      <div slot="btnSty">
        <div class="iconBtn">
          <img src="@/assets/img/personalImg/newsIcon.png" @click="goNews" alt />
        </div>
      </div>
    </common-title>

    <!-- 个人信息 -->
    <div class="fix_layout layout_personalInfo" @click="jumpSignIn">
      <div class="user-info">
        <img :src="userImg" alt />
        <div class="vip-level">
          <p class="ellipsis">{{ userName }}</p>
          <img v-if="userInfo.level" :src="vipLevel[userInfo.level]" alt />
        </div>
      </div>
      <img
        v-if="this.userInfo.id"
        src="@/assets/img/personalCenter/signOut.png"
        alt
        @click="loginOut"
      />
    </div>
    <!-- 会员：未开通展示权益入口，已开通按等级展示入口图 -->
    <div v-if="!userInfo.level" class="vip-container" @click="vipCenter">
      <div class="vip-center">
        <div class="info">
          <i></i>
          <b>会员中心</b>
          <div class="banner">
            <van-swipe class="my-swipe" :show-indicators="false" vertical :autoplay="2000">
              <van-swipe-item v-for="(item, index) in bannerList" :key="index">
                <p class="ellipsis">{{ item.value }}</p>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>
        <div class="btn">
          <img :src="vipBtn[userInfo.level || 0]" alt />
        </div>
      </div>
      <div class="vip-profit">
        <div v-for="(item, ind) in profitList" :key="ind">
          <img :src="item.imgSrc" alt />
          <p>{{ item.name }}</p>
        </div>
      </div>
    </div>
    <div v-else class="vip-purchased" :class="`vip-purchased--${Number(userInfo.level)}`" @click="vipCenter">
      <img class="vip-purchased__img" :src="vipPurchasedImg" alt="" />
      <div class="vip-purchased__overlay">
        <span v-if="vipDeadlineText" class="vip-purchased__expire"
          >有效期至{{ vipDeadlineText }}</span
        >
        <span class="vip-purchased__benefits" @click.stop="vipCenter">查看权益</span>
      </div>
    </div>
    <div class="invitation_center" @click="goInvitationCenter" v-if="basicInfo.entryImg">
      <img class="invitation_center_img" :src="basicInfo.entryImg" alt />
    </div>
    <ul class="personalList">
      <li
        class="fix_layout layoutList"
        v-for="(item, ind) in list"
        :key="ind"
        @click="jumpUrl(item.jumpUrl, item.type, item?.needLogin)"
      >
        <div>
          <img :src="item.imgSrc" alt />
          <p>{{ item.name }}</p>
        </div>
        <img src="@/assets/img/personalCenter/arrowLeft.png" alt />
      </li>
    </ul>
    <Foot />
    <!-- <goToAppVue /> -->
  </div>
</template>

<script>
import { mapState } from 'vuex';
import Foot from '@/components/foot/privacy.vue';
import { reqTypeList } from '@/api/home';
import { isLogin } from '@/utils/common';
import { gioEnterCart } from '@/utils/tools';
import { reqInvitationInfo } from '@/api/invitationCommission';
import { reqLoginOut } from '../../../api';

const VIP_PURCHASED_IMG = {
  20: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/personalCenter-vip1-new.png',
  25: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/personalCenter-vip2-new.png',
  30: 'https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-wap/member_new/personalCenter-vip3-new.png',
};
const VIP_PURCHASED_IMG_DEFAULT = VIP_PURCHASED_IMG[20];

export default {
  components: {
    // goToAppVue,
    Foot,
  },
  data() {
    return {
      defaultAvatar: require('@/assets/img/personalImg/defaultAvatar.png'),
      list: [
        {
          imgSrc: require('../../../assets/img/personalCenter/car.png'),
          name: '我的快递',
          jumpUrl: '/personalCenter/myExpress',
        },
        {
          imgSrc: require('../../../assets/img/personalCenter/orderIcon.png'),
          name: '我的订单',
          jumpUrl: '/personalCenter/myIndent',
          needLogin: true,
        },
        {
          imgSrc: require('../../../assets/img/personalCenter/shopcar.png'),
          name: '购物车',
          jumpUrl: '/shoppingCar?beforePageName=2',
          type: 3,
        },
        {
          imgSrc: require('../../../assets/img/personalCenter/tmall.png'),
          name: '激活中心',
          jumpUrl: '/personalCenter/courseTmall',
        },
        {
          imgSrc: require('../../../assets/img/personalCenter/activityIcon.png'),
          name: '我的活动',
          jumpUrl: '/personalCenter/myActivity',
        },
        {
          imgSrc: require('../../../assets/img/personalCenter/couponIcon.png'),
          name: '优惠券',
          jumpUrl: '/personalCenter/myCoupon',
        },
        {
          imgSrc: require('../../../assets/img/personalCenter/returnsIcon.png'),
          name: '课程升级',
          jumpUrl: '/personalCenter/returnClass?type=1',
        },
        {
          imgSrc: require('../../../assets/img/personalCenter/agreementIcon.png'),
          name: '我的协议',
          jumpUrl: '/personalCenter/myAgreement',
        },
        {
          imgSrc: require('../../../assets/img/personalCenter/newsIcon.png'),
          name: '咨询客服',
          type: 2,
        },
      ],
      profitList: [
        {
          name: '深度试题解析',
          imgSrc: require('../../../assets/img/personalCenter/vip-icon1.png'),
        },
        {
          name: '刷题周报',
          imgSrc: require('../../../assets/img/personalCenter/vip-icon2.png'),
        },
        {
          name: '专属优惠券',
          imgSrc: require('../../../assets/img/personalCenter/vip-icon3.png'),
        },
        {
          name: '长难句学习',
          imgSrc: require('../../../assets/img/personalCenter/vip-icon4.png'),
        },
        {
          name: '更多权益',
          imgSrc: require('../../../assets/img/personalCenter/vip-icon5.png'),
        },
      ],
      vipBtn: {
        0: require('../../../assets/img/personalCenter/vip-know.png'),
        10: require('../../../assets/img/personalCenter/vip-look.png'),
        20: require('../../../assets/img/personalCenter/vip-look.png'),
        30: require('../../../assets/img/personalCenter/vip-look.png'),
        40: require('../../../assets/img/personalCenter/vip-look.png'),
        50: require('../../../assets/img/personalCenter/vip-look.png'),
        60: require('../../../assets/img/personalCenter/vip-look.png'),
      },
      vipLevel: {
        10: "https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-20-new.png",
        20: "https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-20-new.png",
        25: "https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-25-new.png",
        30: "https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-30-new.png",
        40: "https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-20-new.png",
        50: "https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-20-new.png",
        60: "https://iqh-zt.oss-cn-beijing.aliyuncs.com/ark-student-pc/member/level-20-new.png",
      },
      bannerList: [],
      basicInfo: {},
    };
  },
  computed: {
    ...mapState(['userInfo', 'currentYear']),
    userName() {
      if (isLogin()) {
        return this.userInfo.nickName;
      }
      return '登录/注册';
    },
    userImg() {
      if (isLogin()) {
        return this.userInfo.avatar ? this.userInfo.avatar : this.defaultAvatar;
      }
      return this.defaultAvatar;
    },
    vipPurchasedImg() {
      return VIP_PURCHASED_IMG[Number(this.userInfo.level)] || VIP_PURCHASED_IMG_DEFAULT;
    },
    vipDeadlineText() {
      const time = this.userInfo.deadlineEndTime;
      if (!time) return '';
      return String(time).split(' ')[0].replace(/-/g, '/');
    },
  },
  created() {
    this.getTypeList();
  },
  mounted() {
    this.$root.getUserInfo();
    this.getInvitationInfo();
  },
  methods: {
    getInvitationInfo() {
      reqInvitationInfo().then((res) => {
        console.log('res', res);
        this.basicInfo = res;
      });
    },
    goHome() {
      this.$router.go(-1);
      return false;
    },
    goNews() {
      // 跳转消息列表
      this.$router.push({
        path: '/messageList',
      });
    },
    jumpSignIn() {
      if (!this.userInfo.id) {
        this.$router.push({
          path: '/registrationLogin',
          query: {
            redirect: '/personalCenter/Index',
            isChoose: true, // 此参数用来显示备考意向的选择
          }, // 将跳转的路由path作为参数，登录成功后跳转到该路由
        });
      }
    },
    // 跳转链接
    jumpUrl(url, type, needLogin) {
      if (needLogin && !isLogin()) {
        this.$router.push({
          path: '/registrationLogin',
          query: {
            redirect: '/personalCenter/Index',
          },
        });
        return;
      }
      if (url) {
        this.$router.push({
          path: url,
        });
        if (type === 3) {
          gioEnterCart(2);
        }
      } else if (type === 2) {
        // https://chatn9.bjmantis.net/chat/t1/chat.html?mcid=6301&mpid=5ee703e54b419a2a5d2e4ef2
        if (this.$root.$data.isApp) {
          this.$sendToApp(
            'openNewWebView',
            {
              url: `https://iqihang.sobot.com/chat/h5/v7/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3${
                this.userInfo.id || ''
              }`,
            },
            false,
          );
          return;
        }

        window.open(
          `https://iqihang.sobot.com/chat/h5/v7/index.html?sysnum=ba284951843a4490afb0719b16367967&channelid=3&partnerid=${
            this.userInfo.id || ''
          }`,
        );
      }
    },
    // 退出登录
    async loginOut() {
      const res = await reqLoginOut();
      if (res.code === 0) {
        this.$toast('退出成功');
        localStorage.removeItem('accessToken');
        this.$store.dispatch('saveUserInfo', {});
        this.$store.dispatch('saveUserPhone', '');
        setTimeout(() => {
          this.$router.push({
            path: '/home',
          });
        }, 500);

        // eslint-disable-next-line no-undef
        gio('clearUserId');
      }
    },
    openLogin() {
      const param = { redirect: '/invitation/index', ...this.$route.query };
      this.$router.push({
        path: '/registrationLogin',
        query: param,
      });
    },
    // 基础字段配置
    async getTypeList() {
      const { data } = await reqTypeList('MINI_MEMBER_MESSAGE');
      this.bannerList = data;
    },
    vipCenter() {
      this.$router.push({ path: '/personalCenter/member' });
    },
    goInvitationCenter() {
      if (!this.userInfo.id) {
        this.openLogin();
        return;
      }
      this.$router.push({ path: '/invitation/index' });
    },
  },
};
</script>

<style type="text/css" lang="scss">
.centerBox {
  height: 100%;
  padding: 100px 36px 100px 36px;
  overflow: hidden;
  background: #fff;
}

.iconBtn {
  position: absolute;
  top: 0;
  right: 36px;
  height: 100%;
  img {
    width: 36px;
    height: 36px;
  }
}

.fix_layout {
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.topBox {
  height: 45px;
  margin: 34px 0;
}
.typeText {
  display: flex;
  align-items: center;
  color: #000;
  font-size: 33px;
  line-height: 45px;
  img {
    width: 22px;
    height: 14px;
    margin-left: 11px;
  }
}
.user-info {
  .vip-level {
    margin-left: 28px;
    img {
      width: 111px;
    }
  }
}
.layout_personalInfo {
  margin-top: 34px;
  & > img {
    display: block;
    width: 40px;
    height: 40px;
  }
  > div {
    display: flex;
    align-items: center;
    & > img {
      display: block;
      width: 127px;
      height: 127px;
      border-radius: 50%;
    }
    p {
      max-width: 450px;
      color: #333;
      font-size: 51px;
      line-height: 72px;
    }
  }
}
.personalList {
  margin-top: 40px;
  overflow: hidden;
}
.layoutList {
  margin-bottom: 68px;
  & > img {
    display: block;
    width: 14px;
    height: 25px;
  }
  div {
    display: flex;
    align-items: center;
    & > img {
      display: block;
      width: 36px;
      height: 36px;
    }
    p {
      margin-left: 33px;
      color: #333;
      font-size: 29px;
      line-height: 40px;
    }
  }
}
::v-deep .common-foot {
  position: relative;
}
.vip-container {
  box-sizing: border-box;
  width: 678px;
  margin: 0 auto;
  margin: 43px 0 0 0;
  padding: 21px 25px;
  background: url('../../../assets/img/personalCenter/vip-bg.png') no-repeat;
  background-size: 100%;
  .vip-center {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .info {
      display: flex;
      align-items: center;
      justify-content: space-between;
      > i {
        display: inline-block;
        width: 33px;
        height: 33px;
        margin-right: 11px;
        background: url('../../../assets/img/personalCenter/vip-tag.png') no-repeat;
        background-size: 100%;
      }
      b {
        padding-right: 18px;
        color: #ffe2c4;
        font-weight: 500;
        font-size: 25px;
      }
      .banner {
        width: 301px;
        height: 36px;
        overflow: hidden;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0.12) 0%,
          rgba(255, 255, 255, 0) 100%
        );
        border-radius: 7px;
        p {
          padding-left: 7px;
          color: #ffe2c4;
          font-weight: 400;
          font-size: 22px;
          line-height: 36px;
        }
      }
    }
    .btn {
      img {
        width: 149px;
        height: 49px;
      }
    }
  }
  .vip-profit {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 31px;
    div {
      img {
        display: block;
        width: 72px;
        height: 72px;
        margin: 0 auto;
      }
      p {
        padding-top: 14px;
        color: #ffe2c4;
        font-weight: 400;
        font-size: 18px;
        text-align: center;
      }
    }
  }
}
.vip-purchased {
  position: relative;
  width: 678px;
  margin: 43px 0 0 0;
  overflow: hidden;
  cursor: pointer;

  &__img {
    display: block;
    width: 100%;
    height: auto;
  }
  .vip-purchased__overlay {
    .vip-purchased__expire {
      position: absolute;
      top: 87px;
      left: 32px;
      color: #60371c;
      font-weight: 400;
      font-size: 22px;
    }
    .vip-purchased__benefits {
      position: absolute;
      top: 32px;
      right: 33px;
      width: 159px;
      height: 49px;
      color: #ffe2c4;
      font-weight: 500;
      font-size: 25px;
      line-height: 49px;
      text-align: center;
      background: linear-gradient(0deg, #211c20 0%, #3b3734 100%);
      border-radius: 27px;
    }
  }
  &.vip-purchased--25 {
    .vip-purchased__expire {
      color: #254955;
    }
  }
  &.vip-purchased--30 {
    .vip-purchased__expire {
      color: #fae1d0;
    }
    .vip-purchased__benefits {
      color: #2b262d;
      background: #fae1d0;
    }
  }
}

.invitation_center {
  width: 678px;
  height: 109px;
  margin: 22px auto 0;
  overflow: hidden;
  border-radius: 14px;
  .invitation_center_img {
    width: 100%;
    height: 100%;
  }
}
</style>
